import {
  Briefcase,
  Dumbbell,
  Film,
  GraduationCap,
  Heart,
  Home,
  Moon,
  Palette,
  PawPrint,
  PiggyBank,
  Plane,
  Plus,
  ShoppingBag,
  Sparkles,
  Stethoscope,
  TreePine,
  UtensilsCrossed,
  Users,
  type LucideIcon,
} from 'lucide-react';

/** 设计稿 3×6 共 18 项；顺序为行优先 */
export const CHECK_IN_EVENT_OPTIONS: {
  id: string;
  icon: LucideIcon;
  isCustom?: boolean;
}[] = [
  { id: 'Work',          icon: Briefcase },
  { id: 'Family',        icon: Home },
  { id: 'Friend',        icon: Users },
  { id: 'School',        icon: GraduationCap },
  { id: 'Relationship',  icon: Heart },
  { id: 'Travel',        icon: Plane },
  { id: 'Health',        icon: Stethoscope },
  { id: 'Food',          icon: UtensilsCrossed },
  { id: 'Exercise',      icon: Dumbbell },
  { id: 'Finance',       icon: PiggyBank },
  { id: 'Sleep',         icon: Moon },
  { id: 'Hobby',         icon: Palette },
  { id: 'Pet',           icon: PawPrint },
  { id: 'Shopping',      icon: ShoppingBag },
  { id: 'Entertainment', icon: Film },
  { id: 'Nature',        icon: TreePine },
  { id: 'Spirituality',  icon: Sparkles },
  { id: 'Custom',        icon: Plus, isCustom: true },
];

export function getPresetCheckInEvent(id: string) {
  return CHECK_IN_EVENT_OPTIONS.find((e) => e.id === id && !e.isCustom);
}

/** Journal 卡片上的展示用 emoji（无 activity_emoji 时兜底） */
export const PRESET_ACTIVITY_EMOJI: Record<string, string> = {
  Work:          '💼',
  Family:        '🏠',
  Friend:        '👥',
  School:        '🎓',
  Relationship:  '💕',
  Travel:        '✈️',
  Health:        '🏥',
  Food:          '🍜',
  Exercise:      '💪',
  Finance:       '💰',
  Sleep:         '😴',
  Hobby:         '🎨',
  Pet:           '🐾',
  Shopping:      '🛍️',
  Entertainment: '🎬',
  Nature:        '🌲',
  Spirituality:  '✨',
};
